import DashboardLayout from "@/src/components/layout/DashboardLayout";

import { facilitiesApiService } from "@/src/lib/api-services/facilitiesApiServices";
import Progressbar from "@/src/components/loading";
import FacilitesList from "@/src/modules/facilities/facilitiesList";

Facilites.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

function Facilites({ data }) {
    const facilitiesData = data?.facilitiesData;
    if (!facilitiesData) {
        return (
            <div className="justify-center flex flex-row">
                <Progressbar />
            </div>
        );
    }

    return (
        <>
            <div className="bg-gray-100 md:py-8 py-4 px-3 md:px-0">
                <div className="max-w-6xl mx-auto">
                    <h1 className="md:text-2xl text-lg font-bold text-black md:mb-7 mb-4">
                        Facilities
                    </h1>

                    {facilitiesData.length > 0 &&
                        facilitiesData.map((item, index) => (
                            <div
                                key={index}
                                className="bg-white md:p-5 p-3 overflow-hidden rounded-xl shadow-md md:mb-6 mb-4"
                            >
                                <h2 className="md:text-xl text-lg text-black font-bold leading-3 md:mb-6 mb-2">
                                    {item?.categoryType}
                                </h2>

                                <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
                                    {item?.categories?.length > 0 &&
                                        item?.categories?.map((row, index) => (
                                            <FacilitesList
                                                key={row.categoryId}
                                                row={row}
                                                index={index}
                                            />
                                        ))}
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </>
    );
}

export async function getStaticProps() {
    let facilitiesData = null;

    try {
        const response = await facilitiesApiService.facilitiesList();
        facilitiesData = response?.data || [];
    } catch (error) {
        console.error("Failed to fetch facilities data:", error);
    }

    return {
        props: {
            data: {
                facilitiesData,
                seoTitle:
                    "HOD Diagnostic Centre Facilities | Scan | Path Lab | HOD",
                seoDescription:
                    "MRI Scan, CT Scan, Path Lab, PET-CT, XRay, Ultrasound & more at HOD Diagnostic Centre near you. Find test price,facility and cost at centre near you.",
                routerPath: "facilities",
            },
        },
    };
}

export default Facilites;
